import { Steps } from './account-create-form.types.ts';

export const STEPS: Steps = {
	FORM: {
		id: 'FORM',
		title: 'Hesap Oluştur',
		fields: ['userType', 'firstName', 'lastName', 'phone', 'acceptTerms']
	},
	VERIFY: {
		id: 'VERIFY',
		title: 'Doğrulama Kodu',
		fields: ['verificationCode']
	},
	PASSWORD: {
		id: 'PASSWORD',
		title: 'Şifre Oluştur',
		fields: ['password', 'confirmPassword']
	}
} as const;
